import { gql } from "@apollo/client";

export const GET_HISTORIAL_CAPA = gql`
query GetHistorialCapa($idGestionCapa: Int!){
    historialCapaByIdGestionCapa(idGestionCapa: $idGestionCapa){
        idHistorialCapa
        idGestionCapa
        fecha
        descripcion
        idUsuario
        idEstadoCapaNavigation{
            idEstadoReclamo
            descripcion
        }
        idEtapaCapaNavigation{
            idEtapaCapa
            descripcion
        }
        idUsuarioNavigation{
            nombre
            apellido
        }
    }
}`;

export const adaptEtapa = (etapa) => {
  return {
    id: etapa?.idHistorialCapa,
    usuario: !!etapa?.idUsuarioNavigation ?
    etapa?.idUsuarioNavigation?.nombre + ' ' + etapa?.idUsuarioNavigation?.apellido :
    ' - ',
    etapa: etapa?.idEtapaCapaNavigation?.descripcion,
    idEtapa: etapa?.idEtapaCapaNavigation?.idEtapaCapa,
    estado: etapa?.idEstadoCapaNavigation?.descripcion,
    idEstado: etapa?.idEstadoCapaNavigation?.idEstadoReclamo,
    fecha: etapa?.fecha,
    descripcion: etapa?.descripcion
  };
};

export const adaptHistorialArray = (
etapas) =>
{
  return structuredClone(etapas)?.
  map((etapa) => adaptEtapa(etapa));
};